import React, { useRef } from 'react';
import { MembersList } from './MembersList';
import { useStore } from '@/app/providers/StoreProvider';


export const MembersMatch = () => {
  const { forecastStore } = useStore();
  return (
    <div
      className="forecast-members"
      style={{
        height: "100%",
        position: "relative",
      }}
    >
      <h2 className='forecast-members_title'>Список участников</h2>
      <p className='forecast-members_text'>Всего участников: {forecastStore.bets.length}</p>

      <MembersList/>   

    </div>
  );


};